import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as moment from 'moment';
import { from, of } from 'rxjs';
import { catchError, exhaustMap, map, switchMap } from 'rxjs/operators';
import { ECOMMERCE_ENDPOINTS } from '../../shared/models/Constants';
import { IRequestEndpoint } from '../../shared/models/request.model';
import { SharedServiceService } from '../../shared/services/shared-service.service';
import { StorageData } from '../../shared/services/utilities/storage-data.class';
import { errorGetmTienda, getGetmTienda, successGetmTienda } from '../actions';
import { IDataGetmTienda, IResultGetmTienda, ISaveGetmStorage } from './../../private/shared/models/productos';

@Injectable()
export class GetmTiendaEffects {
    private ENDPOINT = ECOMMERCE_ENDPOINTS.get_tienda as IRequestEndpoint;
    private offset = -6;

    constructor(
        private actions$: Actions,
        private httpS: SharedServiceService,
    ) {
        this.offset = (moment().utcOffset() / 60) || -6;
    }

    public getGetmTienda$ = createEffect(
        () => this.actions$.pipe(
            ofType(getGetmTienda),
            map(actions => ({ ...actions, params: { offset: this.offset } })),
            exhaustMap(actions => from(StorageData.getDataStorage(this.ENDPOINT.url))
                .pipe(
                    switchMap((storage: ISaveGetmStorage<IDataGetmTienda>) => this.httpS.getGetmStorage(storage, this.ENDPOINT.url, 'executeRequestByUser', this.ENDPOINT, actions.params)),
                    map((resp: IResultGetmTienda) => successGetmTienda({ data: resp.data })),
                    catchError((err: HttpErrorResponse) => of(errorGetmTienda({ payload: err.error })))
                )
            ),
        )
    );
}

